/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Wechat_Notify_UrlInputs */

const en_admin_settings_fields_wechat_notify_url = /** @type {(inputs: Admin_Settings_Fields_Wechat_Notify_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notify URL (Webhook)`)
};

const zh_admin_settings_fields_wechat_notify_url = /** @type {(inputs: Admin_Settings_Fields_Wechat_Notify_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回调地址（Webhook）`)
};

/**
* | output |
* | --- |
* | "Notify URL (Webhook)" |
*
* @param {Admin_Settings_Fields_Wechat_Notify_UrlInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_wechat_notify_url = /** @type {((inputs?: Admin_Settings_Fields_Wechat_Notify_UrlInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Wechat_Notify_UrlInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_wechat_notify_url(inputs)
	return zh_admin_settings_fields_wechat_notify_url(inputs)
});
export { admin_settings_fields_wechat_notify_url as "admin.settings.fields.wechat_notify_url" }